export const TransformDataForBackend = (formData) => {
    // Create a copy of the data to transform
    const transformedData = {
        // Return all original data fields
        id: formData.id,
        nameHy: formData.nameHy,
        nameEn: formData.nameEn,
        nameRu: formData.nameRu,
        price: formData.price === "" || formData.price === null || formData.price === undefined
            ? 0
            : Number(formData.price),
        type: formData.type,
        expirationDate: formData.expirationDate,
        spiceLevel: formData.spiceLevel,
        orderBefore: formData.orderBefore,
        minimumOrderCount: formData.minimumOrderCount,
        portionHy: formData.portionHy,
        portionEn: formData.portionEn,
        portionRu: formData.portionRu,
        url: formData.url,
        status: formData.status,
        chefId: formData.chefId,
        adultsOnly: Number(formData.adultsOnly ?? 0),

        // Transformed data
        ingridientsDto: formData.ingridientsDto.map((ingredient) => {
            const ingredientEn = ingredient.ingredientEn ||
                ingredient.translations?.find((t) => t.languageCode === "en")?.value || "";
            const ingredientRu = ingredient.ingredientRu ||
                ingredient.translations?.find((t) => t.languageCode === "ru")?.value || "";
            const ingredientHy = ingredient.ingredientHy ||
                ingredient.translations?.find((t) => t.languageCode === "hy")?.value || "";

            return {
                id: ingredient.id || null,
                ingredientEn,
                ingredientRu,
                ingredientHy,
            };
        }),
        adjustableSpiceLevelDtoList: formData.adjustableSpiceLevelDtoList?.map((level) => ({
            id: level.id,
            spiceLevel: level.spiceLevel,
        })) || [],

        dietaryOptionDtoList: formData.dietaryOptionDtoList?.map((diet) => ({
            id: diet.id,
            dietaryOptionValue: diet.dietaryOptionValue,
        })) || [],

        dishTagDto: formData.dishTagDto ? {
            id: formData.dishTagDto.id,
            tag: formData.dishTagDto.tag,
            translations: formData.dishTagDto.translations?.map((translation) => ({
                languageCode: translation.languageCode,
                value: translation.value,
            })) || [],
        } : null,

        dishCuisineTagDto: formData.dishCuisineTagDto ? {
            id: formData.dishCuisineTagDto.id,
            cuisineTag: formData.dishCuisineTagDto.cuisineTag,
            translations: formData.dishCuisineTagDto.translations?.map((translation) => ({
                languageCode: translation.languageCode,
                value: translation.value,
            })) || [],
        } : null,

        dishAdditionDtoList: formData.dishAdditionDtoList || [],
    };

    return transformedData;
};
